/*
* Project: LegalPlace assistant
* File: src\components\option.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

// The bigass component

// init the react env
import React, { Component } from 'react';
import { connect } from 'react-redux';

// to detect the type
import * as classNames from 'classnames';
import { SOptionType } from '../logic/lp_map_utils';

// import components (global components like containers, variables)
import { OptionContainer } from './option_container';
import { VariableContainer } from './variable_container';

import { _lp } from '../logic/wording';

// import utils to generate keys
import { generateId1 } from './utils/misc';

// import atomic  omponents
import LpSingleText from './misc/static';
import LpSingleRadio from './misc/radio';
import LpSingleHidden from './misc/hidden';
import LpText from './misc/text';
import LpCheckBox from './misc/checkbox';
import LpList from './misc/list';
import LpTextArea from './misc/textarea';
import LpWarning from './misc/warning';
import LpDatePicker from './misc/date';
import LpPure from './misc/pure';


// TODO: can be removed
// import { List } from 'immutable';

// used when we want to get the radio group (in modification case)
import { getSiblingsFamily, endEditionMode } from './utils/siblings';
// the condition phase

// importing the condition runtime
import { removeFlatDuplicate } from '../redux/actions/flat_ui';
import {
  removeDuplicateFromOption,
  removeDuplicateFromVariables,
  removeFirstOption,
  removeFirstVariable,
} from '../redux/actions/output';
import { rsDoICome, rsRemove } from './utils/radio_show';

// push Elist
// this let us detect disabled conditions already
import { pushEList } from '../logic/preview_render/condition_manager';
import {
  lpGetOptionById,
  lpUpdateMultiple,
  updateConditions,
} from '../logic/re_index';
import { lpIdGetPure } from '../logic/global_getter';
import { checkUnInitializedSiblings, hasEmptyChildren, checkIfAllFalse } from '../logic/utils/tree_operations';
import RadioGroup from './misc/radio_group';

import lpApp from '../app/lp_app';
import ConditionsEvo from '../logic/condition_evo';

// detecting the first child
function doesMyFatherARadio(id_) {
  if (typeof id_ === 'undefined') {
    return false;
  }
  let id;
  if (id_ && id_.length) [id] = id_; else id = id_;
  if (lpApp.references.getOption(id).meta.type === 'checkbox' && typeof lpApp.indexes.grandpa.getFather(id) === 'undefined') return false;
  let idx = lpApp.indexes.grandpa.getFather(id);
  while (typeof idx !== 'undefined') {
    if (lpApp.references.getOption(idx).meta.type === 'radio' || lpApp.references.getOption(idx).meta.type === 'checkbox') {
      return true;
    }
    idx = lpApp.indexes.grandpa.getFather(idx);
  }
  return false;
}

// styles of show/hide
const showStyle = {
  display: 'block',
};
const hideStyle = {
  display: 'none',
};

// enters the type, the label, (the name if it's a radio), the id,
class _Option extends Component {
  // this is the
  constructor(props) {
    super(props);
    this.multiples = [];

    // Setting up ConditionsEvo's multiple watchers
    ConditionsEvo.setupMultipleWatchers(this.multiples, props.id);

    // console.log(props.id)
    this.params = {
      ...{
        parent: -1,
        type: SOptionType.NONE,
        label: '',
        id: '', // we generate here an ID to affect it to the output <------
        awlad: [],
        variables: [],
        is_checked: false,
        parentId: -1, // <------
        is_multiple: false,
        isDuplicate: false,
        copy: generateId1(2),
      },
      ...this.props,
    };
    // case if we are duplicate
    // initialize the ID and KEY for the duplicate option
    if (this.props.isDuplicate) {
      this.params.id = `${this.params.id}_${this.props.copy}`;
      this.params.lpKey = generateId1(4);
    }
    // test existance using id, parent
    this.state = {
      edit: false,
      show_edit: false,
    };
    // add to multiple global
    if (props.is_multiple && lpApp.indexes.multiples.multiples) {
      // get all the children
      // name of the memeory thing
      if (lpApp.indexes.multiples.exists(props.id)
        && lpApp.indexes.multiples.getMultiple(props.id).length
      ) {
        this.multiples = lpApp.indexes.multiples.getMultiple(props.id);
        ConditionsEvo.setupMultipleWatchers(this.multiples, props.id);
      }
    }
    // setup this for callbacks
    this.modificationButtonCallback = this.modificationButtonCallback.bind(this);
    this.addMultiple = this.addMultiple.bind(this);
    this.updateShowingState = this.updateShowingState.bind(this);
    this.removeMultiple = this.removeMultiple.bind(this);
    this.multiples_len = 0;
  }

  componentWillMount() {
    // update the key, if it exists
    if (this.props.exists) {
      this.params.lpKey = this.props.existant_key;
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const a = getSiblingsFamily(nextProps.lpKey);
    if (a !== null) nextState.edit = a.edit_mode; // eslint-disable-line
  }

  // add multiple clicked
  addMultiple() {
    console.log(this.multiples);
    // add a copy:
    // generate a copy code
    this.multiples.push(generateId1(3));
    // update number length of duplicates of this option
    this.multiples_len += 1;
    // add it to the real global context
    lpApp.indexes.multiples.addMultiple(this.props.id, this.multiples);
    // force update the compoentn
    lpUpdateMultiple(this.props.id, this.multiples);

    lpApp.action_tracker.trackAction('ADD_MULTIPLE', this.props.id);
    updateConditions();
    this.forceUpdate();
  }

  removeMultiple(id) {
    // test if it exists
    let cIdx;
    let cIdxPos;

    // existance of the removed option
    this.multiples.forEach((idx, i) => {
      if (idx === id) {
        cIdx = id;
        cIdxPos = i; // we can delete the ID from the array
      }
    });
    if (!cIdx) return;
    // The multiple exists
    // remove all flats of the duplicate
    this.props.removeFlatUI(id);
    // remove all options and variables of the duplicate
    this.props.removeOptions(id);
    this.props.removeVariables(id);
    // remove the thing from this array
    this.multiples.splice(cIdxPos, 1);
    // decrease the len

    this.multiples_len -= 1;
    lpUpdateMultiple(this.props.id, this.multiples);
    lpApp.indexes.options.delOption(`${this.props.id}_${id}`);

    if (this.multiples_len === 0) lpApp.indexes.multiples.addMultiple(this.props.id, undefined);
    else lpApp.indexes.multiples.addMultiple(this.props.id, this.multiples);

    rsRemove(this.props.id);
    lpApp.action_tracker.trackAction('ADD_MULTIPLE', this.props.id);
    updateConditions();

    this.forceUpdate();
  }

  removeFirst() {
    // update multiples
    this.props.removeFirst(this.multiples[0]);
    const oldMultiples = [...this.multiples];
    this.multiples = this.multiples.slice(1, this.multiples.length);
    this.multiples_len = this.multiples.length;
    for (let i = 0; i < oldMultiples.length; i += 1) if (this.multiples.indexOf(oldMultiples[i]) === -1) lpApp.indexes.options.delOption(`${this.props.id}_${oldMultiples[i]}`);

    lpUpdateMultiple(this.props.id, this.multiples);
    if (this.multiples_len === 0) lpApp.indexes.multiples.addMultiple(this.props.id, undefined);
    else lpApp.indexes.multiples.addMultiple(this.props.id, this.multiples);
    rsRemove(this.props.id);
    updateConditions();

    this.forceUpdate();
  }

  modificationButtonCallback() {
    this.setState({ edit: true }); // this line may be deleted
    // the check here if it's a radio or any shit
    if (this.props.is_multiple) {
      // can be deleted
    }
    this.setState({ show_edit: !this.show_edit });
    // if(this.props.isDuplicate){
    endEditionMode(this.props.exists ? this.props.existant_key : this.props.lpKey, true);

    // }
    // endEditionMode(this.props.exists? this.props.existant_key : this.props.lpKey, true);
    // return;
  }

  updateShowingState(h_s = false) {
    this.setState({ show_edit: h_s });
  }

  render() {
    let result;
    let falseSiblings = true;
    if (this.props.isDuplicate) {
      falseSiblings = checkUnInitializedSiblings(this.props.id, this.props.copy);
    } else falseSiblings = checkUnInitializedSiblings(this.props.id);
    // render atomic component
    // test of possibility
    switch (this.params.type) {
      case SOptionType.HIDDEN:
      case 'hidden':
        result = (
          <LpSingleHidden
            id={this.props.id}
            parent={this.props.parent}
            value={this.props.label}
            ovc="o"
            is_multiple={this.props.is_multiple}
            isDuplicate={this.props.isDuplicate}
            copy={this.props.copy}
            key={generateId1(2)}
            sectionId={this.props.sectionId}
          />
        );
        break;
      case SOptionType.STATIC:
      case 'static':
        result = (
          <div className={this.props.checked && 'wzog-title'}>
            <LpSingleText
              parent={this.props.parent}
              id={this.props.id}
              label={this.props.label}
              ovc="o"
              is_multiple={this.props.is_multiple}
              isDuplicate={this.props.isDuplicate}
              copy={this.props.copy}
              key={generateId1(2)}
              cond_={this.props.is_conditional ? this.end : true}
            />
          </div>
        );
        break;
      case 'RADIOS':
        result = (
          <div>

            <RadioGroup
              parent={this.props.parent}
              id={this.props.id}
              isDuplicate={this.props.isDuplicate}
              copy={this.props.copy}
            />


          </div>
        );
        // this is a special case
        break;
      case SOptionType.RADIO:
      case 'radio':

        // IMPORTANT: midfication button create a new copy name, and pass it
        // edit this
        result = (
          <div>
            { !this.state.show_edit
            /** render single radio, as title */
              && (this.props.checked || this.props.show_m || falseSiblings)
              && (
              <div className="">
                /** the component is checked and ready to put the modification button */
                { this.props.checked && !this.props.show_m
                  && (
                  <div
                    className="wzog-edit-btn-1 icn-pen"
                    onClick={this.modificationButtonCallback}
                    style={{ display: 'block' }}
                  >
                    <span>Modifier</span>
                  </div>
                  )}
                <div
                  onClick={
                    this.props.checked && !this.props.show_m && this.modificationButtonCallback
                  }
                >
                  <LpSingleRadio
                    id={this.props.id}
                    parent={this.props.parent}
                    key={generateId1(1)}
                    group={this.props.parent}
                    label={this.props.label}
                    ovc="o"
                    is_checked={this.props.checked}
                    isDuplicate={this.props.isDuplicate}
                    is_multiple={this.props.is_multiple}
                    copy={this.props.copy}
                  />
                </div>
              </div>
              )
              }


          </div>
        );
        // this is a special case
        break;
        // TODO: The same thing as RADIO buttons
      case SOptionType.CHECKBOX:
      case 'checkbox':
        result = (
          <div className={this.props.checked && (!lpApp.references.getOption(this.props.id).meta.helper || lpApp.references.getOption(this.props.id).meta.helper.length === 0) && 'wzog-options'} key={generateId1(2)}>
            <LpCheckBox
              lpKey={this.props.lpKey}
              lpParent={this.props.lpParent}
              id={this.props.id}
              parent={this.props.parent}
              key={generateId1(1)}
              label={this.props.label}
              is_multiple={this.props.is_multiple}
              isDuplicate={this.props.isDuplicate}
              copy={this.props.copy}
              ovc="o"
            />
          </div>
        );
        break;
      case SOptionType.TEXT:
      case 'text':
        result = (
          <LpText
            id={this.props.id}
            parent={this.props.parent}
            key={generateId1(1)}
            label={this.props.label}
            ovc="o"
            isDuplicate={this.props.isDuplicate}
            is_multiple={this.props.is_multiple}
            copy={this.props.copy}
          />
        );
        break;
      case SOptionType.LIST:
      case 'list':
        result = (
          <LpList
            key={generateId1(4)}
            id={this.props.id}
            label={this.props.label}
            ovc="o"
            is_multiple={this.props.is_multiple}
            isDuplicate={this.props.isDuplicate}
            copy={this.props.copy}
          />
        );
        break;
      case SOptionType.TEXTAREA:
      case 'texarea':
        result = (
          <LpTextArea
            key={generateId1(4)}
            id={this.props.id}
            label={this.props.label}
            ovc="o"
            is_multiple={this.props.is_multiple}
            isDuplicate={this.props.isDuplicate}
            copy={this.props.copy}
          />
        );
        break;
      case SOptionType.DATE:
      case 'date':
        result = (
          <LpDatePicker
            parent={this.props.parent}
            key={generateId1(4)}
            id={this.props.id}
            label={this.props.label}
            ovc="o"
            is_multiple={this.props.is_multiple}
            isDuplicate={this.props.isDuplicate}
            copy={this.props.copy}
          />
        );
        break;
      case SOptionType.PURE:
      case 'brut-text':
        result = (
          <LpPure
            id={this.props.id}
            content={lpApp.references.getOption(this.props.id).meta.content}
            isDuplicate={this.props.isDuplicate}
            copy={this.props.copy}
          />
        );
        break;
      default:
        result = (<div key={this.my_key} />);
        break;
    }

    // Setting the Multiple labels in case of a multiple
    let currentMultipleLabel = '';

    let multipleAddLabel = '';

    let multipleIncrtStep = 1;
    if (this.props.is_multiple) {
      const multipleOptionMeta = lpApp.references.getOption(this.props.id).meta;

      // Adding CTA Label
      multipleAddLabel = (multipleOptionMeta.multipletext.toLowerCase().indexOf('ajouter') === -1
      && multipleOptionMeta.multipletext.toLowerCase().indexOf('hinzufügen') === -1) ? _lp('Ajouter un ') : '';
      multipleAddLabel += multipleOptionMeta.multipletext;

      // Current Multiple label
      currentMultipleLabel = multipleOptionMeta.multipletext;
      if (multipleOptionMeta.multipleIncrtText && typeof (multipleOptionMeta.multipleIncrtText) === 'string' && multipleOptionMeta.multipleIncrtText.trim().length > 0) {
        currentMultipleLabel = multipleOptionMeta.multipleIncrtText;
      }

      // Incrementation step
      if (multipleOptionMeta.multipleIncrt
        && !Number.isNaN(parseInt(multipleOptionMeta.multipleIncrt, 10))
      ) {
        multipleIncrtStep = parseInt(multipleOptionMeta.multipleIncrt, 10);
      }
    }
    let divStyle = Object.assign(
      {},
      this.params.type === SOptionType.REPEATED
      || (this.props.is_conditional && !this.props.cond_end)
        ? hideStyle : showStyle,
    );

    divStyle = Object.assign(divStyle, this.props.type === SOptionType.STATIC ? { marginBottom: '50px' } : {});


    const radioButWeCanShowIt = this.props.type === SOptionType.RADIO
      && this.props.show_m
      && !this.props.checked;
    const act = (this.props.selectedOption !== -1 // this is when the thing is radio
        && !hasEmptyChildren(lpIdGetPure(this.props.selectedOption))) // &&
        || (((this.props.type === SOptionType.CHECKBOX) || (this.props.type === 'checkbox')) && this.props.checked && !hasEmptyChildren(lpIdGetPure(this.props.id)));
    const optionStyle = classNames({
      'wzog-wrapper': (true),
      'wzog-editable': (this.props.type === SOptionType.RADIO),
      first: (!doesMyFatherARadio(lpIdGetPure(this.props.id))),
      active: act,
      'ml-15': this.props.push_left,
      'highlight-second': !lpApp.ops.two_steps.isDiscovered(this.props.id, 'option'),
    });
    let optionResult = (<div />);
    // Here we test the options
    let mL = 0;
    if (lpApp.indexes.multiples.getMultiple(this.props.id)) {
      mL = lpApp.indexes.multiples.getMultiple(this.props.id).length;
    }
    if (!lpApp.ops.two_steps.checkOption(this.props.id.length ? -1 : this.props.id)) {
      optionResult = (
        <div
          className={optionStyle}
          data-type="option"
          data-id={this.props.id}
          data-is-duplicate={this.props.isDuplicate}
          data-copy={this.props.copy}
          style={divStyle}
          key={generateId1(4)}
        >
          {((this.props.copy === -2) && (mL > 0))
            && (
            <div className="option-holder">
              <div onClick={() => this.removeFirst()} className="oh-delete">
                <i className="icn-x" />
                <span>Supprimer</span>
              </div>
              <div className="oh-text">
                {this.props.id
                        && 'multipletext' in lpApp.references.getOption(this.props.id).meta
                        && (`${currentMultipleLabel} ${multipleIncrtStep}`) }
              </div>
            </div>
            )}
          { (radioButWeCanShowIt || this.props.cond_show || falseSiblings
          || (this.props.type === SOptionType.RADIO && this.props.checked))
          && !this.props.dont_show_me && (
          <div className="wzog-options">
            {result}
            {' '}
          </div>
          )}
          {// Here is the shit
            this.props.selectedOption !== -1
            && lpApp.references.getOption(this.props.selectedOption)
            && 'warning' in lpApp.references.getOption(this.props.selectedOption).meta /** there is warning in the component */
            && (lpApp.references.getOption(this.props.selectedOption).meta.warning.length > 0)
            && (
            <LpWarning
              text={lpApp.references.getOption(this.props.selectedOption).meta.warning}
              id={this.props.selectedOption === -1 ? this.props.id : this.props.selectedOption}
            />
            ) }
          {(lpApp.references.getOption(this.props.selectedOption)
          && lpApp.references.getOption(this.props.selectedOption).variables.length > 0)
          && (
          <VariableContainer
            copy={this.props.copy}
            isDuplicate={this.props.isDuplicate}
            is_multiple={this.props.is_multiple}
            id={this.props.selectedOption}
            parent={this.props.selectedOption}
            show
            key={generateId1(1)}
            variables={
              lpApp.references.getOption(this.props.selectedOption).variables.map(
                idx => lpApp.references.getVariable(idx),
              )
            }
          />
          )}
          {(this.props.selectedOption !== -1)
            && (
            <OptionContainer
              copy={this.props.copy}
              isDuplicate={this.props.isDuplicate}
              is_multiple={this.props.is_multiple}
              parent={this.props.selectedOption}
              id={this.props.selectedOption}
              key={`opt_${this.props.key}`}
              variables={
                lpApp.references.getOption(this.props.selectedOption).variables.map(
                  idx => lpApp.references.getVariable(idx),
                )
              }
              children={
                lpApp.references.getOption(this.props.selectedOption).children.map(
                  idx => lpApp.references.getOption(idx).meta,
                )
              }
              aroba
            />
            )}
          {(this.props.type !== SOptionType.HIDDEN
            && (this.props.checked
            || (
              (this.props.type !== SOptionType.RADIO) && (this.props.type !== SOptionType.CHECKBOX))
            )) /** the option is checkked, so we show every single child */
          && (lpApp.references.getOption(this.props.id) && 'warning' in lpApp.references.getOption(this.props.id).meta) /** there is warning in the component */
          && (lpApp.references.getOption(this.props.id).meta.warning.length > 0)
          && (
          <LpWarning
            text={lpApp.references.getOption(this.props.id).meta.warning}
            id={this.props.id}
          />
          ) }

          {(lpApp.references.getOption(this.props.id)
          && lpApp.references.getOption(this.props.id).variables.length > 0)
          && (
          <VariableContainer
            copy={this.props.copy}
            isDuplicate={this.props.isDuplicate}
            is_multiple={this.props.is_multiple}
            id={this.props.id}
            parent={this.props.id}
            show={this.props.checked}
            key={generateId1(1)}
            variables={this.props.variables}
          />
          )}
          {this.props.checked /** we have the component checked, so every single child */
            && (
            <OptionContainer
              copy={this.props.copy}
              isDuplicate={this.props.isDuplicate}
              is_multiple={this.props.is_multiple}
              parent={this.props.id}
              id={this.props.id}
              key={`opt_${generateId1(4)}`}
              variables={this.props.variables}
              children={this.props.awlad}
            />
            )}

          { 'is_multiple' in this.params
            && this.props.is_multiple
            && !this.props.isDuplicate /** here we add the duplicates */
            && this.multiples.map((idx, i) => (
              <div key={`opt_${this.props.id}_${idx}`}>
                <div className="option-holder">
                  <div onClick={() => this.removeMultiple(idx)} className="oh-delete">
                    <i className="icn-x" />
                    <span>Supprimer</span>
                  </div>
                  <div className="oh-text">
                    {this.props.id
                      && 'multipletext' in lpApp.references.getOption(this.props.id).meta
                      && (`${currentMultipleLabel} ${multipleIncrtStep + i + 1}`) }
                  </div>
                </div>
                <Option
                  key={idx}
                  copy={idx}
                  isDuplicate
                  is_multiple={false}
                  original_id={this.props.id}
                  id={this.props.id}
                  parent={this.props.parent}
                  type={this.props.type}
                  label={this.props.label}
                  variables={this.props.variables}
                  awlad={this.props.awlad}
                  dont_show_me
                  checked
                />
              </div>
            ), this)}
          { this.props.checked && 'is_multiple' in this.params
            && this.params.is_multiple
            && (
            <a onClick={this.addMultiple} className="main-link" style={{ cursor: 'pointer' }}>
              <i className="icn-add-outline" />
              {multipleAddLabel}
            </a>
            ) }
        </div>
      );
    }

    return optionResult;
  }
}

function filterSelected(opts, vals) {
  let result = -1;
  opts.forEach((idx, i) => {
    if (vals[i]) result = idx;
  });
  return result;
}

// get all the siblings


const mapStateToProps = (state, ownProps) => {
  let radioState = true;
  if (ownProps.type === SOptionType.RADIO) radioState = false;
  let exists = false;
  let existsKey = '';
  //
  const showMe = true;

  // condition related variables
  let isConditional = false;
  // test if the option has condition, and start new conditionn Runtime

  let meIdx = -1;

  // treat the duplicates as special ones
  if (ownProps.isDuplicate) {
    const cId = `${ownProps.id}_${ownProps.copy}`;
    if (typeof lpGetOptionById(cId) !== 'undefined') {
      const opt = lpGetOptionById(cId);
      radioState = opt.value;
      exists = true;
      existsKey = opt.key;
      meIdx = opt.index;
    }
  } else if (typeof lpGetOptionById(ownProps.id) !== 'undefined') {
    const opt = lpGetOptionById(ownProps.id);
    radioState = opt.value;
    exists = true;
    existsKey = opt.key;
    meIdx = opt.index;
  }

  let showCondition = true;

  const optionRef = lpApp.references.getOption(ownProps.id);
  if (optionRef) {
    if (optionRef.meta.conditional) {
      isConditional = true;
      if ((optionRef.meta.compiledConditions.length > 0)) {
        showCondition = ConditionsEvo.getCondition(ownProps.copy === -2 ? lpIdGetPure(ownProps.id) : `${ownProps.id}_${ownProps.copy}`);

        window.nbr_forced += 1;
        lpApp.indexes.conditions.setCondition(ownProps.copy === -2 ? lpIdGetPure(ownProps.id) : `${ownProps.id}_${ownProps.copy}`, showCondition);
      } else {
        showCondition = true;
      }
    }
  }
  if (meIdx > -1) {
    if (ownProps.type === SOptionType.STATIC || ownProps.type === SOptionType.HIDDEN) {
      // FIXME: antipattern
      // state.output.o[meIdx].value = showCondition;
    }
  }
  if (isConditional && !showCondition) {
    pushEList(ownProps.id);
  }

  if (ownProps.type === SOptionType.STATIC || ownProps.type === 'static') radioState = true;

  // The RADIO case
  let selectedOption = -1;
  if (ownProps.type === 'RADIOS') {
    let cId = ownProps.id;
    if (ownProps.isDuplicate) cId = cId.map(idx => `${idx}_${ownProps.copy}`);

    const vals = cId.map(idx => (lpGetOptionById(idx) ? lpGetOptionById(idx).value : false));
    selectedOption = filterSelected(ownProps.id, vals);
    // console.log(selectedOption)
  }
  return {
    already_exists: exists, // must be deleted
    exists,
    existant_key: existsKey,
    checked: radioState,
    // condtional showing
    cond_show: showMe,
    // condition
    is_conditional: isConditional,
    cond_end: showCondition,
    // for debug
    show_m: rsDoICome(ownProps.id, ownProps.parent, ownProps.isDuplicate, ownProps.copy),
    sectionId: state.contract.currentSection,
    selectedOption,
    push_left: !checkIfAllFalse(ownProps.id.length ? ownProps.id : []),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  removeFlatUI: (idx) => {
    dispatch(removeFlatDuplicate(idx));
  },
  removeOptions: (idx) => {
    dispatch(removeDuplicateFromOption(idx));
  },
  removeVariables: (idx) => {
    dispatch(removeDuplicateFromVariables(idx));
  },
  removeFirst: (fC) => {
    dispatch(removeFirstOption(fC, ownProps.id));
    dispatch(removeFirstVariable(fC, ownProps.id));
  },
});

const Option = connect(mapStateToProps, mapDispatchToProps)(_Option);

// here we map a thing to the store
export default Option;



// WEBPACK FOOTER //
// ./src/components/option.js